import axios from "axios";
import { API_ENDPOINTS } from "../constants/api";

// Create an Axios instance...
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3017/api/teleg_dev/v2.1',
});

// Флаг для предотвращения множественных refresh запросов
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Add a request interceptor to include the access token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      // Проверяем, что токен не пустой и выглядит как JWT
      if (token.trim() && token.split('.').length === 3) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log("Token added to request:", token.substring(0, 20) + "...");
      } else {
        console.warn("Invalid token format, removing from localStorage");
        localStorage.removeItem("access_token");
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors and refresh tokens
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Проверяем различные случаи истечения токена
    const isTokenExpired = 
      error.response?.status === 401 || 
      error.response?.status === 403 ||
      (error.response?.data?.message === "err_user_not_auth" && 
       error.response?.data?.err?.includes("jwt expired")) ||
      error.response?.data?.err?.includes("jwt expired") ||
      error.response?.data?.err?.includes("TokenExpiredError") ||
      error.response?.data?.err?.includes("JsonWebTokenError");

    console.log("Axios error:", {
      status: error.response?.status,
      message: error.response?.data?.message,
      err: error.response?.data?.err,
      isTokenExpired
    });

    if (isTokenExpired && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function(resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axiosInstance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem("refresh_token");
      
      if (!refreshToken) {
        processQueue(error, null);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL || 'http://localhost:3017/api/teleg_dev/v2.1'}${API_ENDPOINTS.REFRESH}`,
          { refreshToken }
        );

        const { access_token, refresh_token } = response.data;
        
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        
        axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
        
        processQueue(null, access_token);
        
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
